import type {ReactElement} from 'react';
import React from 'react';

interface SubrowProps {
  children: React.ReactNode;
  id: string;
}

const DEFAULT_TIMELINE_SUBROW_HEIGHT = 36;

export function BaseTimelineSubrow({...props}: SubrowProps): ReactElement {
  return (
    <div key={props.id} style={{height: '100%', position: 'relative', minHeight: DEFAULT_TIMELINE_SUBROW_HEIGHT}}>
      {props.children}
    </div>
  );
}
